var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.70994 2.12L2.82994 6L6.70994 9.88C7.09994 10.27 7.09994 10.9 6.70994 11.29C6.31994 11.68 5.68994 11.68 5.29994 11.29L0.709941 6.7C0.319942 6.31 0.319942 5.68 0.709941 5.29L5.29994 0.700001C5.68994 0.310001 6.31994 0.310001 6.70994 0.700001C7.08994 1.09 7.09994 1.73 6.70994 2.12Z",
    fill: "#1E334E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftIcon);
export default __webpack_public_path__ + "static/media/left-icon.7b837279846a60011d25a2e6a94bcc2f.svg";
export { ForwardRef as ReactComponent };